import types from 'redux/types/template'
import TemplateApi from 'services/TemplateApi'

export const getMap = () => ({
  types: [types.GET_TEMPLATES, types.GET_TEMPLATES_DONE, types.TEMPLATES_ERROR],
  payload: {
    map: TemplateApi.getMap()
  }
})
